/**
 * Заголовки платформы, которые бэкенд теперь ожидает на каждом запросе (наряду
 * с Content-Type/Authorization). Список разрешённых бэком заголовков:
 * 'Content-Type', 'Authorization', 'App-Platform', 'App-Version'.
 *
 * App-Platform — тип клиента. Значения заданы бэкендом (enum AppPlatform), эта
 * панель — старая админка, поэтому всегда шлёт 'admin-panel-old'.
 * App-Version — uuid версии приложения, генерируется и валидируется бэкендом.
 * Проверок пока нет, поэтому шлём пустую строку.
 */
export const APP_PLATFORM_HEADER = 'App-Platform';
export const APP_VERSION_HEADER = 'App-Version';

export const APP_PLATFORM_VALUE = 'admin-panel-old';
export const APP_VERSION_VALUE = '';

export const appPlatformHeaders: Record<string, string> = {
  [APP_PLATFORM_HEADER]: APP_PLATFORM_VALUE,
  [APP_VERSION_HEADER]: APP_VERSION_VALUE
};
